/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InputBroadcastRequest
 */
export interface InputBroadcastRequest {
    /**
     * 
     * @type {number}
     * @memberof InputBroadcastRequest
     */
    expiration?: number;
    /**
     * 
     * @type {string}
     * @memberof InputBroadcastRequest
     */
    message?: string;
    /**
     * 
     * @type {string}
     * @memberof InputBroadcastRequest
     */
    title?: string;
    /**
     * 
     * @type {number}
     * @memberof InputBroadcastRequest
     */
    zone?: number;
}

/**
 * Check if a given object implements the InputBroadcastRequest interface.
 */
export function instanceOfInputBroadcastRequest(value: object): boolean {
    return true;
}

export function InputBroadcastRequestFromJSON(json: any): InputBroadcastRequest {
    return InputBroadcastRequestFromJSONTyped(json, false);
}

export function InputBroadcastRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): InputBroadcastRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'expiration': json['expiration'] == null ? undefined : json['expiration'],
        'message': json['message'] == null ? undefined : json['message'],
        'title': json['title'] == null ? undefined : json['title'],
        'zone': json['zone'] == null ? undefined : json['zone'],
    };
}

export function InputBroadcastRequestToJSON(value?: InputBroadcastRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'expiration': value['expiration'],
        'message': value['message'],
        'title': value['title'],
        'zone': value['zone'],
    };
}

